import { useCallback } from 'react';

import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';

import useTracking from './useTracking';

const CATEGORY = 'My Courses';

const MY_COURSES_ACTIONS = {
  SUBJECT_SELECT: 'Select a subject',
  FILTER: 'Change Filter',
  SEARCH: 'Search Course',
};

export const genMyCoursesEvent = (action, label) => ({
  category: CATEGORY,
  action,
  label,
});

export const genSearchEventLabel = (userProvider, search) =>
  `User:${userProvider}|Search:${search}`;

function useMyCoursesTracking() {
  const { logAction } = useTracking();
  const { data: userData } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const userProvider = userData?.myExternalProfile?.providerName ?? '';

  const logSubjectSelect = useCallback(
    (label) => {
      logAction(genMyCoursesEvent(MY_COURSES_ACTIONS.SUBJECT_SELECT, label));
    },
    [logAction]
  );

  const logFilterChange = useCallback(
    (filter) => {
      logAction(genMyCoursesEvent(MY_COURSES_ACTIONS.FILTER, filter));
    },
    [logAction]
  );

  const logCourseSearch = useCallback(
    (searchTerm) => {
      logAction(
        genMyCoursesEvent(MY_COURSES_ACTIONS.SEARCH, genSearchEventLabel(userProvider, searchTerm))
      );
    },
    [logAction]
  );

  return { logSubjectSelect, logFilterChange, logCourseSearch };
}

export { useMyCoursesTracking };
